// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"src-components-Header----Navigation-module---Navigation---1uhsn","socialMediaIcons":"src-components-Header----Navigation-module---socialMediaIcons---1Yz2U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation.module.css
// module id = 383
// module chunks = 114276838955818